import { Tooltip } from '@mantine/core'
import { Button } from '../Common/Button'
import type { SimpleAttachAvailability } from '../../utils/officeHelpers'

export interface SimpleAttachButtonProps {
  // Whether the selected email can be attached, and why not when it cannot.
  availability: SimpleAttachAvailability
  sending: boolean
  // The selected email has already been attached to this claim.
  attached: boolean
  onAttach: () => void
}

// "Attach to MC1" in the claim header. Each attach drops another copy into the MC1 ingestion
// mailbox, so once the selected email is attached the button stays off; useSimpleAttach clears
// that when another email is selected.
export function SimpleAttachButton({ availability, sending, attached, onAttach }: Readonly<SimpleAttachButtonProps>) {
  const canAttach = availability.supported && !attached
  const tooltip = attached
    ? 'This email has already been attached to MC1'
    : (availability.reason ?? 'Copy this email into MC1')

  return (
    <Tooltip label={tooltip} position="bottom" withArrow>
      {/* data-disabled instead of disabled so the explanatory tooltip still fires. */}
      <Button
        label={attached ? 'Attached' : 'Attach to MC1'}
        variant="filled"
        size="xs"
        loading={sending}
        data-disabled={!canAttach || undefined}
        aria-disabled={!canAttach}
        onClick={() => {
          if (canAttach) onAttach()
        }}
      />
    </Tooltip>
  )
}
